import React, { useState, useEffect } from "react";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import InviteCode from "./InviteCode";
import Pagination from "../pagination/Pagination";
import M from 'materialize-css';

/*
  @author Created by fireator-cli
  @description InviteCodes Component
  Generated at Wed, 25 Nov 2020 14:39:49 GMT
*/

function InviteCodeList(props) {
  const [currentList, setCurrentList] = useState([]);
  const [selectedInviteCodeId, setSelectedInviteCodeId] = useState('');
  const [selectedInviteCode, setSelectedInviteCode] = useState('');
  const { inviteCodes, firestore } = props;
  const refModal = React.createRef();

  const initLoading = () => {
    let elements = document.querySelectorAll('.modal');
    M.Modal.init(elements);
  };

  useEffect(initLoading, []);

  const deleteSelectedInviteCode = () => {
    firestore
      .collection('inviteCodes')
      .doc(selectedInviteCodeId)
      .delete()
      .then((response) => {
        console.log('Delete InviteCode completed', response);
        return true;
      })
      .catch((error) => {
        console.warn('Delete InviteCode Failed', error);
        return false;
      });
  }

  const renderDeleteDialog = () => {
    return (
      <div ref={refModal} id="modal1" className="modal">
        <div className="modal-content">
          <h5>Are you sure to delete "{selectedInviteCode.deleteModalPropertyShow}" InviteCode?</h5>
          <p>This action will remove ALL the data related to this InviteCode</p>
        </div>
        <div className="modal-footer">
          <a href="#!" onClick={(e) => deleteSelectedInviteCode()} className="modal-close waves-effect btn btn-flat">
            Confirm
          </a>
          <a href="#close" className="modal-close waves-effect btn btn-flat">
            Cancel
          </a>
        </div>
      </div>
    );
  }

  const onDelete = (id, element) => {
    const modal = M.Modal.getInstance(refModal.current);
    setSelectedInviteCodeId(id);
    setSelectedInviteCode(element);
    modal.open();
  };

  return (
    <div className="company-list section">
      <div className="title-section">InviteCodes</div>

      <div className="right-align">
        <Pagination
          limitPerPage={8}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          completeList={inviteCodes}
          setCurrentList={setCurrentList}
        />
      </div>

      {renderDeleteDialog()}

      {currentList.map((inviteCode, index) => {
        return <InviteCode key={inviteCode.id} inviteCode={inviteCode} onDelete={onDelete} />;
      })}
    </div>
  );
}

export default compose(firestoreConnect())(InviteCodeList);
